import { useNavigate, useLocation } from 'react-router-dom'; //Cambio #1 useLocation
import AccountModal from '@jwp/ott-ui-react/src/containers/AccountModal/AccountModal';
import Footer from '@jwp/ott-ui-react/src/components/Footer/Footer';
import { useAccountStore } from '@jwp/ott-common/src/stores/accountStore';
//import { useEffect } from 'react';
import { useEffect, useState } from 'react';

import styles from './Landing.module.scss';

//Cambio 1. Agregue nuevo imports como los de home
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { shallow } from '@jwp/ott-common/src/utils/compare';
//Aqui termina el cambio 1

export default function Landing() {

  const navigate = useNavigate();
  const location = useLocation(); //Cambio 2

  //Cambio 2. Agregue los components
  const { config } = useConfigStore(({ config }) => ({ config }), shallow);
  const content = config?.content || [];
  // Qui termina el cambio 2

  //Cambio 3. Busca el contenido 
  const heroRow = content.find((row: any) => {
    console.log('ROW:', row); // para debug
    return row.type === 'hero' || row.id === 'featured';
  });
  // Aqui termina el cambio 3

  // Para llevar a Home despues de autentificarse como usuario
  const { user } = useAccountStore();

  //Redirige el carousel Cambio 5
   const [carouselImages, setCarouselImages] = useState<{ src: string; alt: string }[]>([]);

  useEffect(() => {
    fetch('https://cdn.jwplayer.com/v2/playlists/GvUGAZJc?format=json')
      .then(r => r.json())
      .then(data => {
        const images = data.playlist.map((item: any) => ({
          src: item.image,
          alt: item.title,
        }));
        setCarouselImages(images);
      })
      .catch(() => {});
  }, []);
  //Termina cambio 5

  useEffect(() => {
  // Solo redirige a Home si NO estamos en un flujo del modal
  if (user && !location.search.includes('u=')) {
    navigate('/');
  }
}, [user, navigate, location]);

  //useEffect(() => {
  //  if (user) {
  //    navigate('/');
  //  }
  //}, [user, navigate]);

  const openLogin = () => {
    navigate('/login?u=login');
  };

  const openRegister = () => {
    navigate('/login?u=create-account');
  };

  return (
    <div className={styles.landing}>
      <div className={styles.overlay} />

      <div className={styles.content}>
        <div className={styles.left}>
          <img
            src="/images/logo_umbra2.png"
            alt="Umbra Stream"
            className={styles.logo}
          />
        </div>

        <div className={styles.right}>
          <div className={styles.formBox}>
            <h2>Iniciar sesión</h2>

            {/* Button Login */}
            <button
              type="button"
              className={styles.loginBtn}
              onClick={openLogin}
            >
              Ingresar
            </button>

            {/* Forgot Password */}
            <div className={styles.actionWrap}>
              <button
                type="button"
                onClick={() => navigate('/login?u=forgot-password')}
                className={styles.secondaryBtn}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </div>

            {/* Registration */}
            <div className={styles.registerBlock}>
              <p className={styles.register}>
                ¿No tienes cuenta?
              </p>

              <button
                type="button"
                onClick={openRegister}
                className={styles.loginBtn}
              >
                Abre el umbral
              </button>
              <p className={styles.registerLegend}>
                Activa tu acceso sin costo y comienza a explorar.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* 
      
      Carousel
      <div className={styles.carousel}>
        <div className={styles.carouselTrack}>
          {[...Array(2)].map((_, loopIndex) => (
            <div key={loopIndex} style={{ display: 'contents' }}>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/POOL_STILL.png" alt="Pool" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/MAD_GOD_STILL.png" alt="Mad God" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/GLORIOUS_STILL.png" alt="Glorious" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images//carousel/SADNESS_STILL.png" alt="Sadness" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/SHE_WILL_STILL.png" alt="She Will" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/TEXAS_STILL.png" alt="Texas" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/WE_ARE_STILL_HERE_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/LIVING_DEAD_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/HENRY_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/HELLBENDER_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/DRAGULA_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/DEATHGASM_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/CHOPPING_MALL_STILL.png" alt="We Are Still Here" />
              </div>
            </div>
          ))}
        </div>
      </div>

      */}

      {/* Carousel */}  {/* Cambio 6 */}
      <div className={styles.carousel}>
        <div className={styles.carouselTrack}>
          {carouselImages.length > 0 && [...Array(2)].map((_, loopIndex) => (
            <div key={loopIndex} style={{ display: 'contents' }}>
              {carouselImages.map((img, i) => (
                <div key={i} className={styles.carouselItem}>
                  <img src={img.src} alt={img.alt} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Termina el cambio 6 */}

      <Footer text="© Versatile Communications 2025" />
      
      {/* Aqui se incluye el MODAL JWP */}
      <AccountModal />

    </div>
  );
}